export const unitEndpoints = {
  getUnits: `/unit`,
};
